import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CampaignTable } from "@/pages/email/EmCampaigns";

export default function EmAnalytics() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/email-marketing/campaigns").then((r) => setRows(r.data.filter((c) => c.stats?.recipients > 0 || ["sent", "sending", "paused"].includes(c.status)))).catch(() => setRows([])); }, []);
  if (!rows) return null;
  const t = rows.reduce((a, c) => { ["sent", "delivered", "opened", "clicked", "unsubscribed", "bounced", "complaints"].forEach((k) => { a[k] = (a[k] || 0) + (c.stats?.[k] || 0); }); return a; }, {});
  const pct = (x, y) => (y ? `${((100 * x) / y).toFixed(1)}%` : "–");
  return (
    <div className="space-y-4" data-testid="em-analytics">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {[["Sent", t.sent || 0], ["Delivery rate", pct(t.delivered, t.sent)], ["Click rate", pct(t.clicked, t.delivered)], ["Unsubscribe rate", pct(t.unsubscribed, t.delivered)]].map(([l, v]) => (
          <div key={l} className="bg-white border border-slate-200 rounded-xl p-4" data-testid={`em-analytics-${l.toLowerCase().replace(/ /g, "-")}`}><p className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold">{l}</p><p className="text-2xl font-bold tabular-nums">{v}</p></div>))}
      </div>
      <CampaignTable rows={rows} testId="em-analytics-table" />
      <p className="text-[11px] text-slate-400">Opens are estimates. Website sessions and sales from campaign links will be attributed through GA4 UTM tags (utm_source=tedops, utm_medium=email) in a later phase.</p>
    </div>
  );
}
